import _ from 'lodash'
import {generateBidders as ixGenerateBidders}  from './bidders/ix_generator';
import {generateBidders as sovrnGenerateBidders} from './bidders/sovrn_generator';
import {generateBidders as appnexusGenerateBidders} from './bidders/appnexus_generator';
import {generateBidders as openxGenerateBidders} from './bidders/openx_generator';
// import {generateBidders as pubmaticGenerateBidders} from './bidders/pubmatic_generator';
// import {generateBidders as rubiconGenerateBidders} from './bidders/rubicon_generator';
// import {generateBidders as emxGenerateBidders} from './bidders/emx_generator';

const bidderGenFuncs = [];
bidderGenFuncs.push(ixGenerateBidders);
bidderGenFuncs.push(appnexusGenerateBidders);
bidderGenFuncs.push(openxGenerateBidders);
bidderGenFuncs.push(sovrnGenerateBidders);
// bidderGenFuncs.push(pubmaticGenerateBidders);
// bidderGenFuncs.push(rubiconGenerateBidders);
// bidderGenFuncs.push(emxGenerateBidders);

export function generateAllBidders(adUnit, sizes) {
  sizes = _.filter(sizes, size => size !== 'fluid')
  return _.reduce(bidderGenFuncs, (bidders, currGenFunc) => {
    bidders = _.assign(bidders, currGenFunc(adUnit, sizes))
    return bidders;
  }, {})
}
